import { ClipboardCopy } from 'lucide-react';
import { toast } from 'sonner';

export default function CopyToClipboard({ text }: { text: string }) {
    return (
        <button
            onClick={() => {
                navigator.clipboard.writeText(text);
                toast.success('Copied to clipboard');
            }}
            className="text-muted-foreground hover:text-foreground ml-2 cursor-pointer"
        >
            <ClipboardCopy className="w-6 h-6" />
        </button>
    );
}
